import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import AlertImagePicker from "../AlertImagePicker";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Embedded "Add more photos" panel that lives below the gallery thumbs.
 * Owns the pending-upload state and the POST. On success it refreshes the
 * parent's image list and clears itself.
 */
export default function AlertImageUploadPanel({ alertId, maxRemaining, onUploaded, onCancel }) {
  const [pending, setPending] = useState([]);
  const [uploading, setUploading] = useState(false);

  const handleUpload = async () => {
    if (pending.length === 0) {
      toast.error("Pick at least one photo");
      return;
    }
    setUploading(true);
    try {
      const r = await axios.post(
        `${API}/alerts/${alertId}/images`,
        { images: pending },
        { withCredentials: true },
      );
      toast.success(`Added ${pending.length} photo${pending.length === 1 ? "" : "s"}`);
      onUploaded(r.data?.images_count);
      setPending([]);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="border border-gray-200 rounded-sm p-2 bg-gray-50 space-y-2" data-testid={`alert-add-${alertId}`}>
      <AlertImagePicker
        images={pending}
        onChange={setPending}
        max={maxRemaining}
        disabled={uploading}
      />
      <div className="flex gap-2">
        <button
          type="button"
          onClick={handleUpload}
          disabled={uploading || pending.length === 0}
          className="text-[11px] bg-black hover:bg-gray-800 text-white font-bold font-body rounded-sm px-3 py-1 disabled:opacity-50"
          data-testid={`alert-add-submit-${alertId}`}
        >
          {uploading ? "Uploading…" : "Upload"}
        </button>
        <button
          type="button"
          onClick={() => { setPending([]); onCancel(); }}
          disabled={uploading}
          className="text-[11px] text-gray-700 hover:text-black font-body px-2"
          data-testid={`alert-add-cancel-${alertId}`}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
